import { render, staticRenderFns } from "./trading_activity_list.vue?vue&type=template&id=e5a6486a"
import script from "./trading_activity_list.vue?vue&type=script&lang=js"
export * from "./trading_activity_list.vue?vue&type=script&lang=js"
import style0 from "./trading_activity_list.vue?vue&type=style&index=0&id=e5a6486a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports